import React, { Component } from 'react';
import { Form, FormControl } from 'react-bootstrap';

// Interface with parent
//
interface MapRenameDWLayerProps {
  handleFormChangeInputFromComponent: Function,
  handleLayerNameChangeFromComponent: Function,
  handleOnSaveNewLayerName: Function,
  layer: any
}

interface MapRenameDWLayerState {
  layerTitle: string
}

class MapRenameDWLayer extends Component<MapRenameDWLayerProps, MapRenameDWLayerState> {
  constructor(props: any) {
    super(props);

    console.log("MapRenameDWLayer this.props", this.props);
    console.log("MapRenameDWLayer props.layer.get(title)", props.layer ? props.layer.get("title") : '');

    this.state = {layerTitle:  props.layer ? props.layer.get("title") : ''};

    this.handleFormChangeInput = this.handleFormChangeInput.bind(this);
    this.handleLayerNameChange = this.handleLayerNameChange.bind(this);
  }

  // Listen for change to the layer name
  //
  handleFormChangeInput(event: any) {
    console.log("handleFormChangeInput > event", event);
    console.log("handleFormChangeInput > this.props", this.props);
    console.log("handleFormChangeInput > this.state", this.state);
    let value = event.target.value;
    console.log("INPUT value", value);
    
    if (this.props.layer){
      console.log("INPUT value", this.props.layer);
    //  this.props.layer.values_.title = value;
    }
    this.setState({
      layerTitle: value,
    });

    const { handleFormChangeInputFromComponent /*, handleLayerNameChangeFromComponent*/ } = this.props;
    handleFormChangeInputFromComponent(value);
    //handleLayerNameChangeFromComponent(value);
  }

  // Pass the event up to parent so that it can be handled there
  //
  async handleLayerNameChange(event: any) {
    console.log("020122 handleLayerNameChange > event", event);
    console.log("020122 handleLayerNameChange > this.props", this.props);
    console.log("020122 handleLayerNameChange > this.state", this.state);
    let value = this.state.layerTitle;
    console.log("020122 APPLY value", value);
    if (this.props.layer){
      this.props.layer.set("title",value)
      const { /*handleFormChangeInputFromComponent, handleLayerNameChangeFromComponent,*/ handleOnSaveNewLayerName } = this.props;
      handleOnSaveNewLayerName(value);
    }
    //handleFormChangeInputFromComponent(value);
    //handleLayerNameChangeFromComponent(value);
  }

  render() {
    return (
      <div>
        <Form.Group className="mb-3" controlId="formLayerName">
          <Form.Label>Layer Name</Form.Label>
          <FormControl
            value={this.state.layerTitle}
            placeholder="Enter layer name"
            aria-label={"Enter layer name"}
            onChange={this.handleFormChangeInput}
          />
        </Form.Group>
        {/*<Button className="mt-2" variant="primary" onClick={this.handleLayerNameChange}>Apply</Button>*/}
      </div>
    )
  }
}

export default MapRenameDWLayer;
